import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { UserService } from 'src/app/shared/services/user.service';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-incoming-call-dialog',
  standalone: false,
  templateUrl: './incoming-call-dialog.component.html',
  styleUrl: './incoming-call-dialog.component.scss',
})
export class IncomingCallDialogComponent {
  public callerName: string = 'John Doe';
  public userData;

  private timeoutRef: any;

  constructor(
    private loadingService: LoadingService,
    private matDialogRef: MatDialogRef<IncomingCallDialogComponent>,
    private chatService: ChatService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userData = data.user;
    this.callerName = this.userData?.email ?? this.userData;

    this.timeoutRef = setTimeout(() => {
      this.declineCall();
    }, 20000);
  }

  public acceptCall(): void {
    clearTimeout(this.timeoutRef);
    this.matDialogRef.close({ accepted: true });
  }

  public declineCall(): void {
    clearTimeout(this.timeoutRef);
    this.matDialogRef.close({ accepted: false });
  }
}
